import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';
import CheckFilledIcon from '../../assets/icons/check-filled.svg?react';
import { Column } from '../Column/Column';
import { Row } from '../Row/Row';
import { Space } from '../Space/style';
import {
	DeviceContainer,
	DevicesSelectorListContainer,
	DevicesSelectorListTitle,
	SelectedDeviceIcon,
	Separator,
} from './style';

export interface Device {
	key: string;
	label: string;
	onClick?: () => void;
}

export interface DevicesListProps {
	lists: Array<{ title?: string; selected?: string; options: Array<Device> }>;
}

export function DevicesSelectorList({ lists }: DevicesListProps) {
	const theme = useThemeContext();

	return (
		<DevicesSelectorListContainer>
			{lists.map(({ title, selected, options }, index) => {
				if (options.length === 0) {
					return <div key={title}></div>;
				}

				return (
					<div key={title}>
						{title && <DevicesSelectorListTitle>{title}:</DevicesSelectorListTitle>}
						<Column $gap={24}>
							{options.map((option: Device) => (
								<DeviceContainer key={option.key} onClick={option.onClick}>
									<Row $gap={12} $vcenter={true}>
										<SelectedDeviceIcon $visible={option.key === selected}>
											<CheckFilledIcon fill={theme.colors.brand.primary[300]} />
										</SelectedDeviceIcon>
										{option.label}
									</Row>
								</DeviceContainer>
							))}
						</Column>
						{index < lists.length - 1 && (
							<>
								<Space size={18} direction={'vertical'} />
								<Separator />
								<Space size={18} direction={'vertical'} />
							</>
						)}
					</div>
				);
			})}
		</DevicesSelectorListContainer>
	);
}
